import React, { useState, useEffect, useCallback } from 'react';
import type { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import clsx from 'clsx';
import { ValuePropCardsV2 } from 'types/studio/studio';
import styles from './ValuePropCardsV2Slider.module.scss';
import ValuePropCardsItem from '../ValuePropCardsV2Item/ValuePropCardsV2Item';

export type ValuePropCardsV2SliderProps = {
  sectionType: string;
  options?: EmblaOptionsType;
  cards: ValuePropCardsV2['cards'];
  visibleOnPageLoad: boolean;
} & Pick<ValuePropCardsV2, 'addSlider'> &
  Pick<ValuePropCardsV2, 'theme'>;

const ValuePropCardsV2Slider: React.FC<ValuePropCardsV2SliderProps> = ({
  sectionType,
  options,
  cards,
  addSlider,
  theme,
  visibleOnPageLoad
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
  }, [emblaApi, onSelect]);

  return (
    <div className={styles.emblaPosition}>
      <div className={styles.embla}>
        <div className={styles.emblaViewport} ref={emblaRef}>
          <div className={styles.emblaContainer}>
            {cards &&
              cards.map((item, index) => (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  className={clsx(
                    styles.emblaSlide,
                    emblaApi && selectedIndex === index ? styles.emblaActiveSlide : '',
                    emblaApi && selectedIndex === index ? styles.emblaActiveContainer : ''
                  )}>
                  <ValuePropCardsItem
                    sectionType={sectionType}
                    image={item.image}
                    portableText={item.portableText}
                    description={item.description}
                    addSlider={addSlider}
                    activeState={emblaApi && selectedIndex === index}
                    theme={theme}
                    imageSizes="100vw"
                    visibleOnPageLoad={visibleOnPageLoad}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValuePropCardsV2Slider;
